import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store";
import { ColumnFilterProps, FilterOperator } from "../../types/filters";
import { transformTimeToEndOfDay } from "../../utils/dateHandler";
import { DatePicker } from "../DatePicker";

export const DateFilter: React.FC<ColumnFilterProps> = ({
  tableName,
  fieldName,
  filterSelectorValue,
  filterUpdateAction,
}) => {
  const minValueId = `${fieldName}Min`;
  const maxValueId = `${fieldName}Max`;
  const minValue = useSelector((state: RootState) => filterSelectorValue(state, minValueId));
  const maxValue = useSelector((state: RootState) => filterSelectorValue(state, maxValueId));
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <DatePicker
        value={minValue?.value ? new Date(minValue.value as string) : undefined}
        placeHolder={t(`${tableName}.filters.dateFrom`)}
        withIcon={true}
        onChange={(value) => {
          dispatch(
            filterUpdateAction({
              id: minValueId,
              name: fieldName,
              operator: FilterOperator.IsGreaterOrEqualTo,
              value: value.toISOString(),
            })
          );
        }}
      />
      <DatePicker
        value={maxValue?.value ? new Date(maxValue.value as string) : undefined}
        placeHolder={t(`${tableName}.filters.dateTo`)}
        withIcon={true}
        onChange={(value) => {
          const endOfDay = transformTimeToEndOfDay(value.toISOString());

          dispatch(
            filterUpdateAction({
              id: maxValueId,
              name: fieldName,
              operator: FilterOperator.IsLessOrEqualTo,
              value: endOfDay,
            })
          );
        }}
      />
    </>
  );
};
